import styled from 'styled-components';

export const Superficie = styled.div`
  color: #18334e;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  line-height: 1.5;
  &,
  * {
    box-sizing: border-box;
  }
  h2,
  h3 {
    color: #18334e;
    font-family: inherit;
  }
  h2 {
    font-size: 23px;
    font-weight: 700;
    margin: 0;
  }
  h3 {
    font-size: 15px;
    font-weight: 600;
    margin: 0 0 12px;
  }
  label {
    color: #304b66;
    font-size: 13px;
  }
  input[type='range'] {
    width: 100%;
    margin: 10px 0 14px;
    accent-color: #1264b9;
  }
  input:focus-visible {
    outline: 3px solid #3b8eea;
    outline-offset: 3px;
  }
`;

export const Colunas = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(260px, 1fr);
  @media (max-width: 700px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const Painel = styled.div`
  padding: 24px;
  min-width: 0;
  @media (max-width: 420px) {
    padding: 16px;
  }
`;

export const Rodape = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 18px 24px;
  border-top: 1px solid #e2e9f0;
  background: white;
  @media (max-width: 420px) {
    padding: 16px;
  }
`;
